export enum AuthenticationPageEnum {
  Login = "login",
  Register = "register",
  ForgotPassword = "forgot-password",
  ResetPassword = "reset-password",
  Verify = "verify",
  EditProfile = "edit-profile",
  ChangePassword = "change-password",
}
